import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e5dca01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "today-list" }
const _hoisted_2 = {
  key: 0,
  class: "list-unstyled"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  class: "relation-text"
}
const _hoisted_6 = { class: "weekday" }
const _hoisted_7 = {
  key: 1,
  class: "no-events"
}

import { computed, ref, watch } from 'vue'
import { TodayItem } from './TodayItem'
import { useRelationTextBuilder } from '@/rd/RelationPath'
import { DateTime } from 'luxon'

const DISPLAY_LIMIT = 5


export default /*#__PURE__*/_defineComponent({
  __name: 'TodayList',
  props: {
    items: {}
  },
  setup(__props: any) {

const props = __props;



const { getRelationText } = useRelationTextBuilder()

const showAll = ref(false)

const displayItems = computed(() => {
    if (showAll.value || props.items.length <= DISPLAY_LIMIT)
        return props.items
    return props.items.slice(0, DISPLAY_LIMIT)
})

const remainingCount = computed(() => {
    if (showAll.value) return 0
    return Math.max(0, props.items.length - DISPLAY_LIMIT)
})

// Reset showAll when items change (different day selected)
watch(() => props.items, () => {
    showAll.value = false
})

function getWeekday(item: TodayItem) {
    const date = item.date
    if (!date.year || !date.month || !date.day) return ''
    try {
        return DateTime.utc(date.year, date.month, date.day).toFormat('EEE')
    } catch {
        return ''
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (displayItems.value.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayItems.value, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id
            }, [
              _createElementVNode("img", {
                src: item.image,
                alt: ""
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: item.pageUrl,
                  class: "link-dark description"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.displayText), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                (item.relationPath)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "your " + _toDisplayString(_unref(getRelationText)(item.relationPath)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(getWeekday(item)), 1)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, "No events on this day")),
    (remainingCount.value > 0)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          class: "show-more",
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showAll.value = true), ["prevent"]))
        }, " show " + _toDisplayString(remainingCount.value) + " more ", 1))
      : _createCommentVNode("", true)
  ]))
}
}

})